<template>
  <div
    :class="[
       noGrid ? '' : (grid ? 'col-md-' + grid : 'col-md-12'),
       noGrid ? '' : 'col-sm-12'
    ]"
  >
    <div :class="`mb-2 ${inputGroup ? 'form-group' : ''}`">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span
          v-if="!item && label"
          class="small text-warning"
          style="font-size: 10px"
          v-b-tooltip.hover
          title="Campo vazio!"
          ><i class="fas fa-exclamation"></i
        ></span>
        <b-link
          v-if="ajuda"
          href="#"
          @click.prevent="void 0"
          class="mb-2"
          variant="info"
          v-b-popover.hover.top="ajuda"
        >
          <i class="fas fa-info-circle"></i>
        </b-link>
        <span v-if="required" class="text-danger">*</span>
        <small>{{ sublabel }}</small>
      </label>

      <div :class="inputGroup ? 'input-group mb-3' : ''">
        <div class="input-group-prepend" v-if="inputGroup">
          <button class="btn btn-light" @click.prevent="">
            <i :class="iconBtn" v-if="iconBtn"></i>
            <span v-else>{{ btnText }}</span>
          </button>
        </div>
        <input
          v-if="type == 'money'"
          v-model.lazy="item"
          v-money="money"
          class="form-control"
          v-on:input="
            $emit('input', uppercase ? toUpper(item) : item), $emit('change')
          "
          :readonly="readonly"
          :disabled="disabled"
          :required="required"
        />
        <input
          v-else
          v-model="item"
          v-on:input="
            $emit('input', uppercase ? toUpper(item) : item), $emit('change')
          "
          :type="type ? type : 'text'"
          class="form-control"
          :class="
            label == undefined ? (mt == undefined ? 'mt-4' : `mt-${mt}`) : ''
          "
          :min="min"
          :max="max"
          :readonly="readonly"
          :disabled="disabled"
          :placeholder="placeholder ? placeholder : label"
          :required="required"
          :style="uppercase ? 'text-transform: uppercase' : ''"
          ref="input"
          :maxlength="maxlength"
          :minlength="minlength"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { Money } from "v-money";
export default {
  components: { Money },
  props: [
    "type",
    "value",
    "label",
    "sublabel",
    "required",
    "grid",
    "readonly",
    "disabled",
    "placeholder",
    "mt",
    "inputGroup",
    "noGrid",
    "iconBtn",
    "btnText",
    "uppercase",
    "ajuda",
    "min",
    "max",
    "maxlength",
    "minlength",
  ],
  data() {
    return {
      item: null,
      money: {
        decimal: ",",
        thousands: "",
        prefix: "",
        suffix: "",
        precision: 0,
        masked: false,
      },
    };
  },
  beforeMount() {
    // if (this.type == "money") {
    //     this.item = this.value + ",00";
    // } else {
    //     this.item = this.value;
    // }
    this.item = this.value;
  },
  watch: {
    value(n, o) {
      this.item = n;
    },
  },
  methods: {
    toUpper(item) {
      return item.toUpperCase();
    },
  },
};
</script>
